import { Action } from 'redux';

export const GET_CITATION_ISSUE_REPORT = 'reports-citation/GET_CITATION_ISSUE_REPORT';
// export interface GetCitationIssueReportAction extends Action<typeof GET_CITATION_ISSUE_REPORT> { };
export const getCitationIssueReport = (data: SelectReportData) => ({
  type: GET_CITATION_ISSUE_REPORT,
  payload: data,
});
export const SET_CITATION_ISSUE_REPORT = 'reports-citation/SET_CITATION_ISSUE_REPORT';
export const setCitationIssuedReport = (data: ReadonlyArray<CitationReportTable>) => {
  return {
    type: SET_CITATION_ISSUE_REPORT,
    payload: data,
  };
};
export interface SetCitationReport extends Action<typeof SET_CITATION_ISSUE_REPORT> {
  readonly payload: ReadonlyArray<CitationReportTable>;
}
// Bulk citation
export const GET_BULK_CITATION_ISSUE_REPORT = 'reports-citation/GET_BULK_CITATION_ISSUE_REPORT';
export const getBulkCitationIssueReport = (data: SelectReportData) => ({
  type: GET_BULK_CITATION_ISSUE_REPORT,
  payload: data,
});
export const SET_BULK_CITATION_ISSUE_REPORT = 'reports-citation/SET_BULK_CITATION_ISSUE_REPORT';
export const setBulkCitationIssuedReport = (data: ReadonlyArray<any>) => {
  return {
    type: SET_BULK_CITATION_ISSUE_REPORT,
    payload: data,
  };
};
export interface SetBulkCitationReport extends Action<typeof SET_BULK_CITATION_ISSUE_REPORT> {
  readonly payload: ReadonlyArray<CitationReportTable>;
}
//Bulk citation end

// bulk payment
// Bulk citation
export const GET_BULK_CITATION_PAYMENT = 'reports-citation/GET_BULK_CITATION_PAYMENT';
export const getBulkCitationPayment = (data: any) => ({
  type: GET_BULK_CITATION_PAYMENT,
  payload: data,
});
export const SET_BULK_CITATION_PAYMENT = 'reports-citation/SET_BULK_CITATION_PAYMENT';
export const setBulkCitationPayment = (data: any) => {
  return {
    type: SET_BULK_CITATION_PAYMENT,
    payload: data,
  };
};
export interface SetBulkCitationPayment extends Action<typeof SET_BULK_CITATION_PAYMENT> {
  readonly payload: ReadonlyArray<CitationReportTable>;
}
//Bulk citation end

// bulk payment end
export const GET_CITATION_SUMMARY = 'report-citation/GET_CITATION_SUMMARY';
export const getCitationSummarys = (data: SelectReportData) => ({
  type: GET_CITATION_SUMMARY,
  payload: data,
});

export const SET_CITATION_SUMMARY = 'report-citation/SET_CITATION_SUMMARY';
export const setCitationSummarys = (data: ReadonlyArray<CitationSummaryTable>) => ({
  type: SET_CITATION_SUMMARY,
  payload: data,
});

export interface SetCitationSummaryAction extends Action<typeof SET_CITATION_SUMMARY> {
  readonly payload: ReadonlyArray<CitationSummaryTable>;
}

// Repeat Offenders Report
export const GET_REPEAT_OFFENDERS = 'reports-citation/GET_REPEAT_OFFENDERS';
export const getRepeatOffenders = (data: RepeatOffendersReportRequest) => ({
  type: GET_REPEAT_OFFENDERS,
  payload: data,
});

export const SET_REPEAT_OFFENDERS = 'reports-citation/SET_REPEAT_OFFENDERS';
export const setRepeatOffenders = (data: any) => ({
  type: SET_REPEAT_OFFENDERS,
  payload: data,
});

export interface SetRepeatOffendersAction extends Action<typeof SET_REPEAT_OFFENDERS> {
  readonly payload: ReadonlyArray<RepeatOffendersReportResponse>;
}

export const SET_REPEAT_OFFENDERS_REQUEST = 'reports-citation/SET_REPEAT_OFFENDERS_REQUEST';
export const setRepeatOffendersRequest = (data: RepeatOffendersReportRequest | undefined) => ({
  type: SET_REPEAT_OFFENDERS_REQUEST,
  payload: data,
});

export interface SetRepeatOffendersRequestAction extends Action<typeof SET_REPEAT_OFFENDERS_REQUEST> {
  readonly payload: RepeatOffendersReportRequest;
}

export const GENERATE_REPEAT_OFFENDERS_PDF = 'reports-citation/GENERATE_REPEAT_OFFENDERS_PDF';
export const generateRepeatOffendersPdf = (data: RepeatOffendersPdfReportRequest) => ({
  type: GENERATE_REPEAT_OFFENDERS_PDF,
  payload: data,
});

export type ReportsCitationAction =
  | SetCitationReport
  | SetBulkCitationReport
  | SetCitationSummaryAction
  | SetBulkCitationPayment
  | SetRepeatOffendersAction
  | SetRepeatOffendersRequestAction;
